import { render, staticRenderFns } from "./PorcentagemFaturamento.vue?vue&type=template&id=0fd0233a&scoped=true&"
import script from "./PorcentagemFaturamento.vue?vue&type=script&lang=js&"
export * from "./PorcentagemFaturamento.vue?vue&type=script&lang=js&"
import style0 from "./PorcentagemFaturamento.vue?vue&type=style&index=0&id=0fd0233a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd0233a",
  null
  
)

export default component.exports